<template>
  <div data-testid="dashboardMetadataAside">
    <cc-error :show="!loading && fatalError" @click="init" />
    <cc-loading :show="loading && !fatalError" />
    
    <div v-if="!loading && !fatalError">
      <div class="settings splitter-content">
        <div class="col">
          <cc-form-input
            labelFor="dashboard_name"
            :label="$t('common:single_word.name', 'Name')"
            :state="dbNameState"
            :invalidFeedback="dbNameFeedback"
            :info-bubble-text="$t('dashboard:edit_dashboard_aside.form.info.name', 'The name of the dashboard. Required')"
          >
            <b-form-input
              id="dashboard_name"
              v-model="dashboardName"
              data-testid="txtDashboardName"
              :disabled="formDisabled"
            />
          </cc-form-input>
          <cc-form-input
            labelFor="dashboard_desc"
            :label="$t('common:single_word.description', 'Description')"
            :info-bubble-text="$t('dashboard:edit_dashboard_aside.form.info.description', 'A brief description of the dashboard')"
          >
            <b-form-textarea
              id="dashboard_desc"
              v-model="dbDesc"
              no-resize
              data-testid="txtDashboardDesc"
              style="height: 200px;"
              :disabled="formDisabled"
            />
          </cc-form-input>
          <cc-form-input
            labelFor="label_select"
            :label="$t('common:single_word.labels', 'Labels')"
            :info-bubble-text="$t('dashboard:edit_dashboard_aside.form.info.labels', 'Labels for the dashboard')"
          >
            <multiselect
              id="label_select"
              :taggable="true"
              :multiple="true"
              v-model="selectedLabels"
              :options="availableLabels"
              @tag="labelAdded"
              data-testid="dashboardLabels"
              :disabled="formDisabled"
            />
          </cc-form-input>

        </div>
      </div>
    </div>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import api from '../api';
import Multiselect from 'vue-multiselect';

export default {
  name: 'dashboard-metadata-aside',
  components: {
    Multiselect
  },
  props: {
    save: {
      type: Boolean
    },
    currentDashboard: {
      type: Object
    }
  },
  data() {
    return {
      loading: true,
      fatalError: false,
      formDisabled: true,
      dashboardName: '',
      dbDesc: '',
      availableLabels: [],
      selectedLabels: [],
    };
  },
  computed: {
    dbNameState() {
      return !(this.dashboardName == '' || this.dashboardName.length > 50);
    },
    dbNameFeedback() {
      if (!this.dashboardName) return this.$t('common:single_word.required', 'Required');
      if (this.dashboardName.length > 50) return this.$t('dashboard:edit_dashboard_aside.form.name.error.length', 'Name cannot exceed 50 characters');
      return "";
    },
    labelsUpdated() {
      if (this.selectedLabels.length != this.currentDashboard.labels.length) return true;
      for (let label of this.currentDashboard.labels) {
        if (this.selectedLabels.indexOf(label) == -1) return true;
      }
      for (let label of this.selectedLabels) {
        if (this.currentDashboard.labels.indexOf(label) == -1) return true;
      }
      return false;
    },
    dbNameUpdated() {
      return this.currentDashboard.name != this.dashboardName;
    },
    dbDescUpdated() {
      return this.currentDashboard.description != this.dbDesc;
    },
  },
  watch: {
    save(newSave) {
      if (newSave) this.saveSettings();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.loading = true;
      this.fatalError = false;

      this.formDisabled = !this.$s.can.access('dashboard..entity.update');

      try {
        this.setSettings();

        setTimeout(() => { this.emitHeight(); }, 100);
      } catch (err) {
        console.log(err);
        this.fatalError = true;
      }

      this.loading = false;
    },
    async saveSettings() {
      this.$emit('update:save', false);
      
      if (!this.dbNameUpdated && !this.dbDescUpdated && !this.labelsUpdated) {
        console.error('no changes to save');
        this.$Toastr = {
          type: 'warn',
          message: this.$t('common:phrase.no_change', 'No changes to save')
        };
        return;
      }

      if (!this.dbNameState) {
        // TODO: change to match other error messages
        this.$Toastr = {
          type: 'error',
          message: this.$t('user_settings:user_settings.form_errors', 'Please fix the form errors')
        };
        return;
      }

      try {
        let changes = {
          name: this.dashboardName,
          description: this.dbDesc,
          labels: this.selectedLabels
        };

        this.$emit('update-dashboard-metadata', changes);
      } catch (err) {
        console.error(err);
        this.$Toastr = {
          type: 'error',
          message: this.$t('user_settings:user_settings.save_error', 'Error saving settings')
        };
      }
    },
    setSettings() {
        this.dashboardName = this.currentDashboard.name;

        this.dbDesc = this.currentDashboard.description;

        this.availableLabels = [...this.currentDashboard.labels];
        this.selectedLabels = [...this.currentDashboard.labels];
    },
    async cancelChanges() {
      this.loading = true;
      this.setSettings();
      this.loading = false;
    },
    emitHeight() {
      this.$emit('heightChanged', this.$el.offsetHeight);
    },
    labelAdded(newLabel) {
      newLabel = newLabel.toLowerCase();
      this.availableLabels.push(newLabel);
      this.selectedLabels.push(newLabel);
    },

  }
};
</script>

<style>
.settings {
    display: flex;
    flex-direction: row;
}

.btn-row .btn {
    margin: 0 1em;
}
</style>
